@if (addressBook$|async; as data) {
  <div class="row col-12 col-sm-12 col-md-12 col-lg-12 my-account-container" [ngClass]="isMobile? 'px-0 m-0':''">
    @if (!isMobile) {
      <div class="col-3 col-sm-3 my-account-left-nav">
        <app-my-account-left-sidenav [navState]="'AddressBookNavNode'"></app-my-account-left-sidenav>
      </div>
    }
    <div class="col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
      <h1 class="myProfileTopHeader m-0">{{'common.text_account_addressBook'|cxTranslate}}
      </h1>
      <div class="myAddressBookBody">
        <div class="d-flex col-12 bodyTopSection" [ngClass]="isMobile?'flex-column':''">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 addressbook-section"
            [ngClass]="isMobile ? '':'pr-0'">
            <div class="row col-xs-12 col-sm-12 col-md-12  searchboxHolder" [ngClass]="isMobile ? '':'p-0'">
              <input type="text" placeholder="{{'common.address_search_input_text'|cxTranslate}}"
                [ngClass]="isMobile?'col-8':' col-8'" class="" [(ngModel)]="searchInput"
                (ngModelChange)="searchResetter()" (keydown.enter)="searchApi(searchKey.value,0)"
                #searchKey>
                <button class="btn btn-search-address " [ngClass]="isMobile ?'col-4': ' col-3'"
                  (click)="searchApi(searchKey.value,0)">{{'common.address_search_input_text'|cxTranslate}}<img
                class="hover-img" src="/icons/link-grey.svg" style="width: 16px;"></button>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 " [ngClass]="isMobile ? 'mt-3' :'right-mover'">
              <a [routerLink]="'/add-address'"
                class="color_red">{{'common.text_account_addressBook_addAddress_label'|cxTranslate}} <img
              src="/icons/link-right-blue.svg" alt="" width="22px"></a>
            </div>
          </div>
          <div class="bodyContainerSection">
            @if (data?.addressBook.length !== 0) {
              <div class="row col-12 m-0 p-0 border_over">
                @for (address of data?.addressBook; track address) {
                  <div class=" col-xs-12 col-sm-6 col-md-6 border_add py-4">
                    <div class="row col-xs-12 col-sm-12 col-md-12">
                      <ul class="pull-left " [ngClass]="isMobile ? 'col-9' : 'col-10'">
                        <li>
                          @if (address?.dropShipFlag) {
                            <p class="blue-text">
                            {{'common.text_account_dropship_address'|cxTranslate}}</p>
                          }
                        </li>
                        @if (address?.sapCustomerID) {
                          <li class="main-address-field">
                          {{address?.sapCustomerID}}</li>
                        }
                        <li class="main-address-field">
                          {{address?.companyName}}<br>
                        </li>
                        @if (address?.companyAddressTwo) {
                          <li>
                            {{address?.companyAddressTwo}}<br>
                          </li>
                        }
                        @if (address?.line1) {
                          <li class="main-address-field">{{address?.line1}}</li>
                        }
                        @if (address?.region?.name) {
                          <li class="main-address-field">
                          {{address?.region?.name}}</li>
                        }
                        @if (address?.line2) {
                          <li class="main-address-field">{{address?.line2}}</li>
                        }
                        <li>
                          {{address.postalCode}}
                          ,&nbsp;{{address?.town}}<br>{{address?.country?.name}}<br>
                        </li>
                      </ul>
                      @if (address?.dropShipFlag) {
                        <div class="pull-right d-flex flex-column"
                          [ngClass]="isMobile ? 'col-3 align-items-end': 'col-2'"
                          >
                          <a (click)="openDeleteDialog(address)">
                            <span><img style="width: 15px;" src="/icons/close_kb_blue.svg"
                            alt=""></span>
                          </a>
                          <a (click)="openEditpage(address.id)">
                            <span style="width: 15px;"><img src="/icons/pencil-fill.svg" alt=""></span>
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="noAddressData">
                <b>{{'common.text_account_addressBook_noSavedAddresses'|cxTranslate}}</b>
              </div>
            }
          </div>
        </div>
        <div class="product__list--wrapper mt-4">
          <div class="pagination-bar">
            <div class="pagination-toolbar">
              <div class="row sort-refine-bar">
                <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
                  <div class="pagination-result">
                    <label>{{'common.search_page_showing_text'|cxTranslate}}
                      {{($any(data)?.pagination.pageSize *
                      $any(data)?.pagination.currentPage)+1 }}-
                      @if ($any(data)?.pagination.pageSize *($any(data)?.pagination.currentPage+1) < $any(data)?.pagination.totalResults) {
                        <span
                          >{{$any(data)?.pagination.pageSize
                        *($any(data)?.pagination.currentPage+1)}}</span>
                      }
                      @if ($any(data)?.pagination.pageSize *($any(data)?.pagination.currentPage+1) > $any(data)?.pagination.totalResults) {
                        <span
                        >{{$any(data)?.pagination.totalResults}}</span>
                      }
                      {{'common.search_page_of_text'|cxTranslate}}
                      {{$any(data)?.pagination.totalResults}}
                    {{'common.search_page_result_text'|cxTranslate}}</label>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination addressbook-pagination"
                  [ngClass]="isMobile? 'mb-3': ''">
                  <kb-pagination [pagination]="$any(data)?.pagination" [defaultPage]="0"
                  (viewPageEvent)="changePageCustom(searchInput,$event, $any(data)?.searchPageData)"></kb-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }